'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoadingIndicator = function (_Component) {
  _inherits(LoadingIndicator, _Component);

  function LoadingIndicator() {
    _classCallCheck(this, LoadingIndicator);

    return _possibleConstructorReturn(this, (LoadingIndicator.__proto__ || Object.getPrototypeOf(LoadingIndicator)).apply(this, arguments));
  }

  _createClass(LoadingIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isLoading = _props.isLoading,
          descriptiveText = _props.descriptiveText;


      if (!isLoading) {
        return null;
      }
      return _react2.default.createElement(
        'span',
        { 'aria-label': descriptiveText, className: 'LoadingIndicator' },
        _react2.default.createElement(
          'svg',
          { className: 'LoadingIndicator-svg', viewBox: '0 0 66 66' },
          _react2.default.createElement('circle', { className: 'LoadingIndicator-path', cx: '33', cy: '33', r: '30' })
        )
      );
    }
  }]);

  return LoadingIndicator;
}(_react.Component);

LoadingIndicator.propTypes = {
  isLoading: _propTypes2.default.bool.isRequired,
  descriptiveText: _propTypes2.default.string.isRequired
};

LoadingIndicator.defaultProps = {
  isLoading: true,
  descriptiveText: 'Loading...'
};

exports.default = LoadingIndicator;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/Utility/LoadingIndicator.js
// module id = 231
// module chunks = 0